<template>
    <div>
        <b-button id="tooltipfilter" 
            :active="false" class="shadow-lg" 
            variant="dark"
            href="#" tabindex="0"
        >
            <img src="../assets/interface/filter.svg" 
                class="mx-n1" 
                style="height:1.5em;filter:invert(90%)"
            />
        </b-button>
        <b-tooltip placement="rightbottom" :show.sync="show" target="tooltipfilter" variant="light" triggers="focus">
            <b-list-group flush class="my-n1 mx-n2" style="font-size:1.1em">
                <b-list-group-item v-for="(data, index) in filter" 
                    class="text-left" 
                    variant="dark" 
                    :style="index == 0 ? 'border-top-right-radius:4px;border-top-left-radius:4px' : 
                        index+1 == filter.length ? 'border-bottom-right-radius:4px;border-bottom-left-radius:4px' : ''" 
                    :key="index" 
                    button 
                    :active="selected == data.filter" 
                    :disabled="data.disabled" 
                    @click="filtere(data.filter)"
                >
                    <img :src="data.icon" width="36" />
                    <span class="text-center">{{ data.beschreibung }}</span>
                </b-list-group-item>
            </b-list-group>
        </b-tooltip>
    </div>
</template>

<script>
import { setAlert } from '../tools'
import { updateAngebote } from '../store/apiHelper'
import { BListGroup, BListGroupItem, BTooltip } from "bootstrap-vue"

export default {
    name: "UebersichtControlFilter",
    components: {
        BListGroup, 
        BListGroupItem,
        BTooltip
    },
    data(){
        return{
            show: false,
            selected: 0,
            filter: [
                {icon: require("../assets/map/carmarker.svg"), beschreibung: "Fahrer", filter: 2},
                {icon: require("../assets/map/usermarker.svg"), beschreibung: "Mitfahrer", filter: 1},
                {icon: require("../assets/map/combinedmarker.svg"), beschreibung: "Fahrer\\Mitfahrer", filter: 0}
            ]
        }
    },
    methods:{
        async filtere(f){
            if(f > -1){
                try {
                    var res = await updateAngebote(f)
                    res = res.sort((a,b) => a.id - b.id)
                    this.selected = f
                    this.$emit('input', res)
                }
                catch (err) {
                    setAlert(this, err.response.data, 'Laden fehlgeschlagen', 'danger')
                }
                this.show = false
            }
        }
    },
    async mounted(){
        await this.filtere(0)
    }
}
</script>